import { useState, useEffect, useMemo, useCallback } from "react";
import {
  Button,
  Dropdown,
  Form,
  Stack,
  Container
} from "react-bootstrap";
import Countdown from "react-countdown";
// @ts-ignore
import { confirm } from "react-bootstrap-confirmation";
import { AiOutlineClear } from "react-icons/ai";
// @ts-ignore
import { v4 as uuidv4 } from "uuid";
import { AiOutlineReload } from "react-icons/ai";
// @ts-ignore
import { Chance } from "chance";
import toast from "react-hot-toast";

import {
  getKenoTimeLimitTowerMasterApi,
  getKenoRemainTimeApi,
  getKenoWinApi,
  getKenoRoundApi,
  getKenoMaxBetApi,
  setBuyDiamondApi,
} from "../../apis/coupon";

import { store } from "../../store";
import {
  customToastStyle,
  customToastSuccessStyle,
} from "../../configs/constants";

import useResponsive from "../../hooks/useResponsive";

const animationPerTime = 0.5 * 1000;

const delay = (time: number) => {
  return new Promise((resolve, reject) => {
    setTimeout(() => {
      resolve(true);
    }, time);
  });
};

const chance = new Chance();

const scoreTable = {
  1: {
    1: 2,
  },
  2: {
    1: 1,
    2: 7,
  },
  3: {
    2: 3,
    3: 25,
  },
  4: {
    2: 1,
    3: 8,
    4: 80,
  },
  5: {
    3: 3,
    4: 15,
    5: 500,
  },
  6: {
    3: 1,
    4: 7,
    5: 50,
    6: 1500,
  },
  7: {
    3: 1,
    4: 3,
    5: 20,
    6: 100,
    7: 5000,
  },
  8: {
    4: 2,
    5: 10,
    6: 50,
    7: 1000,
    8: 15000,
  },
};

export default function KenoBoard() {
  const [account] = store.useState("account");
  const [userInfo, setUserInfo] = store.useState("userInfo");

  const [gamePeriod, setGamePeriod] = useState(5 * 60 * 1000);
  const [timeLoaded, setTimeLoaded] = useState(false);

  const [endDate, setEndDate] = useState(Date.now() + gamePeriod);
  const [pickEnable, setPickEnable] = useState(true);

  const [kb, setKb] = useState([]);
  const [picked, setPicked] = useState([]);
  const [pickLimit] = useState(8);
  const [maxPricePerGame] = useState(20);
  const [winningDraw, setWinningDraw] = useState([]);
  const [animationDraw, setAnimationDraw] = useState([]);
  const [winningDrawList, setWinningDrawList] = useState([]);
  const [betAmount, setBetAmount] = useState("1");
  const [currentRound, setCurrentRound] = useState(0);
  const [repeatNumber, setRepeatNumber] = useState(0);
  const [repeatNumberView, setRepeatNumberView] = useState(1);
  const [betDrawNumber, setBetDrawNumber] = useState(0); // count bet game
  const [showAnimation, setShowAnimation] = useState(false);
  const [dbMaxBetAmount, setDbMaxBetAmount] = useState("0");

  const isSmall = useResponsive(1100)
  const isLessSmall = useResponsive(700)

  const amountList = useMemo(() => {
    const min = 1;
    const max = Math.min(4, parseInt(dbMaxBetAmount));
    const result = [];
    for (let i = min; i <= max; i++) {
      result.push(i);
    }
    if (parseInt(dbMaxBetAmount) > 5) {
      result.push(5);
    }
    if (parseInt(dbMaxBetAmount) > 10) {
      result.push(10);
    }
    if (parseInt(dbMaxBetAmount) > max) {
      result.push(parseInt(dbMaxBetAmount));
    }
    return result;
  }, [dbMaxBetAmount]);

  const showPlayAgain = useMemo(() => {
    if (account && betDrawNumber !== 0 && betDrawNumber === repeatNumber) {
      return true;
    }
    return false;
  }, [account, repeatNumber, betDrawNumber]);

  const confirmBet = useMemo(() => {
    return betDrawNumber < repeatNumber;
  }, [betDrawNumber, repeatNumber])

  useEffect(() => {
    (async () => {
      const period = (await getKenoTimeLimitTowerMasterApi()) || "4";
      setGamePeriod(parseFloat(period) * 60 * 1000);
      setDbMaxBetAmount(await getKenoMaxBetApi());
      const round = await getKenoRoundApi();
      setCurrentRound(round);
      const remainTime = await getKenoRemainTimeApi();
      setEndDate(Date.now() + remainTime * 1000);
      setTimeLoaded(true);
    })();
  }, []);

  const clearHandler = async () => {
    if (pickEnable) {
      const res = await confirm(`Are you sure to clear picked numbers?`);
      if (res) {
        setPicked([]);
      }
    }
  };

  const submitHandler = useCallback(async () => {
    if (!pickEnable) return;
    const diamond = parseFloat((userInfo as any)?.diamond) || 0;
    const _betAmount = Number(betAmount) * Number(repeatNumberView)
    if (diamond < _betAmount) {
      return toast("You don't have enough diamond to bet", customToastStyle);
    }
    const res = await confirm(
      `You will bet ${_betAmount} diamond for this game.`
    );
    if (res) {
      const diamond = parseFloat((userInfo as any)?.diamond) || 0;
      let newBalance = diamond - _betAmount;

      setRepeatNumber(repeatNumberView)

      if (newBalance < 0) {
        newBalance = 0;
      }

      setUserInfo({
        ...(userInfo as any),
        diamond: newBalance,
      });

      setBuyDiamondApi(account, -_betAmount);

      toast("Bet successfully", customToastSuccessStyle);
    }
  }, [repeatNumber, pickEnable, userInfo, setUserInfo]);

  const renderer: any = ({
    minutes,
    seconds,
    completed,
  }: {
    minutes: number;
    seconds: number;
    completed: boolean;
  }) => {
    if (minutes === 0 && seconds <= 3) {
      setPickEnable(false);
    }

    if (completed) {
      <div style={{ color: "#27ff00", display: "flex" }}>
        <div
          style={{
            width: 50,
            height: 50,
            justifyContent: "center",
            alignItems: "center",
            display: "flex",
            borderRadius: 10,
            borderStyle: "solid",
            borderWidth: 1,
            borderColor: "gray",
          }}
        >
          0
        </div>
        <div
          style={{
            width: 20,
            height: 50,
            justifyContent: "center",
            alignItems: "center",
            display: "flex",
          }}
        >
          :
        </div>
        <div
          style={{
            width: 50,
            height: 50,
            justifyContent: "center",
            alignItems: "center",
            display: "flex",
            borderRadius: 10,
            borderStyle: "solid",
            borderWidth: 1,
            borderColor: "gray",
          }}
        >
          0
        </div>
      </div>;
    }
    return (
      <div style={{ color: "#27ff00", display: "flex" }}>
        {minutes === 0 && seconds <= 3 && seconds !== 0 && (
          <div className="full-screen">
            <div className="count-down">
              <h1>{seconds}</h1>
            </div>
          </div>
        )}
        <div
          style={{
            width: 50,
            height: 50,
            justifyContent: "center",
            alignItems: "center",
            display: "flex",
            borderRadius: 10,
            borderStyle: "solid",
            borderWidth: 1,
            borderColor: "gray",
          }}
        >
          {minutes}
        </div>
        <div
          style={{
            width: 20,
            height: 50,
            justifyContent: "center",
            alignItems: "center",
            display: "flex",
          }}
        >
          :
        </div>
        <div
          style={{
            width: 50,
            height: 50,
            justifyContent: "center",
            alignItems: "center",
            display: "flex",
            borderRadius: 10,
            borderStyle: "solid",
            borderWidth: 1,
            borderColor: "gray",
          }}
        >
          {seconds}
        </div>
      </div>
    );
  };

  useEffect(() => {
    let newKb: any = [];
    let add: any = 1;
    // init rows of Keno board
    for (let r = 0; r < 8; r++) {
      newKb.push([]);
    }

    // populate Keno board
    for (let r = 0; r < newKb.length; r++) {
      for (let x = 1; x <= 10; x++) {
        newKb[r].push(add as never);
        add++;
      }
    }

    setKb(newKb);
  }, []);

  /**
   * Finish the game.
   * - disable the board
   * - generate winning numbers
   * - show winnint numbers
   */
  const finGetWin = useCallback(async () => {
    let firstPicked = [];
    if (picked.length === 0) {
      firstPicked = quikPik(9);
    }
    await showWinningDraw(firstPicked);
  }, [picked, repeatNumber, picked, betDrawNumber, betAmount, userInfo]);

  /**
   * Generate NPC games.
   */
  const genNPC = () => {
    // generate dummy data for other players
    let players = [];
    const n = chance.integer({ min: 10, max: 20 });
    for (let i = 0; i < n; i++) {
      players.push([]);
    }
    for (let y = 0; y < players.length; y++) {
      players[y].push(
        // @ts-ignore
        chance.unique(chance.natural, pickLimit, { min: 1, max: 80 })
      );
    }
    return players;
  };

  /**
   * GUI Utility.
   * Generate and display the winning Keno spots.
   */
  const showWinningDraw = useCallback(async (firstPicked: any) => {
    setShowAnimation(true);
    const total = await getKenoWinApi();
    const _total = [...total];

    const d = total.splice(0, 20);
    const a = [...total];

    let winningIndex = 0;
    let animationIndex = 0;
    for (let i = 0; i < _total.length; i++) {
      if (i % 3 === 0) {
        setAnimationDraw((prev) => {
          const _prev: any = [...prev];
          _prev[0] = d[winningIndex];
          return _prev;
        });

        await delay(animationPerTime);

        setAnimationDraw((prev) => {
          const _prev: any = [...prev];
          _prev[0] = -1;
          return _prev;
        });
        setWinningDraw((prev) => {
          const _prev: any = [...prev];
          _prev[winningIndex] = d[winningIndex];
          winningIndex++;

          return _prev;
        });
      } else {
        setAnimationDraw((prev) => {
          const _prev: any = [...prev];
          _prev[0] = a[animationIndex];
          animationIndex++;

          return _prev;
        });
      }
      await delay(animationPerTime);
    }

    setAnimationDraw([]);

    setCurrentRound((prev) => {
      return prev + 1;
    });

    setShowAnimation(false);

    // set the winning spots
    const prev: any = [...winningDrawList]

    const _picked = picked.length > 0 ? picked : firstPicked;
    const matches = _picked.filter((n: Number) => d.indexOf(n) > 0);
    const matchCount = matches.length;

    let scoreCount = 0;
    if (matchCount !== 0) {
      // @ts-ignore
      scoreCount = scoreTable[_picked.length][matchCount] || 0;
    }

    // calculate score and reduce balance
    if (betAmount && confirmBet) {
      setBetDrawNumber((prevNumber) => prevNumber + 1);

      let totalReward = scoreCount * parseFloat(betAmount);

      if (totalReward) {
        const diamond = parseFloat((userInfo as any)?.diamond) || 0;
        let newBalance = diamond + totalReward;

        if (newBalance < 0) {
          newBalance = 0;
        }

        setUserInfo({
          ...(userInfo as any),
          diamond: newBalance,
        });

        setBuyDiamondApi(account, totalReward);
        toast(
          `You win ${totalReward} diamond in this game`,
          customToastSuccessStyle
        );
      } else {
        toast(`You didn't win this game.`, customToastSuccessStyle);
      }
    }

    prev.push({ picked: _picked, winning: d, scoreCount });

    setWinningDrawList(prev);

    setWinningDraw([]);
  }, [repeatNumber, picked, betDrawNumber, betAmount, userInfo, confirmBet]);

  /**
   * GUI Form Utility.
   * QuikPik: auto select a draw of numbers of length `n`.
   * @param {event} e - Click event.
   */
  const quikPik = (pickNumber: number) => {
    if (!pickEnable && pickNumber !== 9) {
      return;
    }
    // determine to use default pickLimit or user defined qpNum.
    let num = pickNumber === 9 ? 8 : pickNumber;
    const d = chance.unique(chance.natural, num, { min: 1, max: 80 });
    setPicked(d);
    return d;
  };

  /**
   * GUI Form Utility.
   * Process clicked elements within the Keno game board.
   * @param {event} e - Click event
   * @param {number} val - The cell that was clicked within the Keno game board
   */
  const addPicked = (e: any, val: any) => {
    e.preventDefault();
    if (!pickEnable) {
      return;
    }
    // guard check limit met
    if (picked.length < pickLimit) {
      let nPicked = picked.slice(0);

      nPicked.push(val as never);
      setPicked(nPicked);

      // disable the clicked item
    }
  };

  const removePicked = (e: any, val: any) => {
    e.preventDefault();
    if (!pickEnable) {
      return;
    }
    // guard check limit met
    setPicked((prev: never[]) => {
      const _prev: never[] = [...prev];
      return _prev.filter((item) => item !== val);
    });
    // if (picked.length < pickLimit) {

    //   // disable the clicked item
    // }
  };

  /**
   * Render Helper.
   * Display a number `n`.
   * @param {number} n - The number (from and array iteration) to display
   */
  const renderNum = (n: any) => {
    return (
      <span className="numbers__your-num" key={n}>
        {n + " "}
      </span>
    );
  };
  const renderPicked = (n: any) => {
    return (
      <div
        style={{
          fontWeight: "bold",
          color: "#27ff00",
          minWidth: 30,
          height: 30,
          borderRadius: 30,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          background: "#fff",
        }}
        key={n}
      >
        {/* 🗙 */}
        {n}
      </div>
    );
  };

  /**
   * Render helper.
   * Builds the HTML/JSX required to render the Keno board.
   * Additional check made here to "x" the cell for when QuikPik is used.
   */
  const renderBoard = () => {
    return (
      <div className={`board `}>
        <div className="count-container">
          {confirmBet && (
            <div
              className="full-screen-keno-submit"
              onClick={() => {
                toast(
                  "Since you have already submitted your game, you can bet on the next game.",
                  customToastStyle
                );
              }}
            ></div>
          )}
          {((!showAnimation && account && parseFloat(betAmount) > 0) ||
            !account) &&
            timeLoaded &&
            ((
              <Countdown
                date={endDate}
                key={endDate}
                renderer={renderer}
                onComplete={async () => {
                  if (betAmount && currentRound + 1 < repeatNumber) {
                    const diamond = parseFloat((userInfo as any)?.diamond) || 0;
                    if (parseFloat(betAmount) > diamond) {
                      // balance error => finish game
                      toast(
                        "Please buy diamond to play game",
                        customToastStyle
                      );
                    }
                  }

                  await finGetWin();

                  setPickEnable(true);
                  setEndDate(Date.now() + gamePeriod);
                }}
              />
            ) as any)}
        </div>

        {
          // @ts-ignore
          // scoreTable[picked.length] &&
          <div className="reward-container">
            <div className="reward-match">
              <span>Match</span>
              {
                // @ts-ignore
                scoreTable[picked.length] &&
                // @ts-ignore
                Object.keys(scoreTable[picked.length]).map((item) => {
                  return <div key={uuidv4()}>{item}</div>;
                })
              }
            </div>

            <div className="horizontal-devider" />

            <div className="reward-match">
              <span>Pays</span>
              {
                // @ts-ignore
                scoreTable[picked.length] &&
                // @ts-ignore
                Object.values(scoreTable[picked.length]).map((item: any) => {
                  return <div key={uuidv4()}>x{item}</div>;
                })
              }
            </div>
          </div>
        }


        <div className="board__card">
          {kb.map((row: any) => (
            <div className="row" key={uuidv4()}>
              {row.map((col: any) => {
                return (
                  <div
                    style={{ position: "relative" }}
                    className={`col ${winningDraw.indexOf(col as never) !== -1
                      ? "win-draw-number"
                      : ""
                      } ${animationDraw.indexOf(col as never) !== -1
                        ? "animation-draw-number"
                        : ""
                      }`}
                    key={uuidv4()}
                    onClick={(e) => {
                      if (picked.indexOf(col as never) === -1) {
                        addPicked(e, col);
                      } else {
                        removePicked(e, col);
                      }
                    }}
                  >
                    {picked.indexOf(col as never) === -1
                      ? renderNum(col)
                      : renderPicked(col)}
                  </div>
                );
              })}
            </div>
          ))}
        </div>
        <div style={{ color: "#fff", marginTop: 10 }}>
          {confirmBet ? `You bet ${betAmount} diamond in this draw` : "No bet"}
        </div>
      </div>
    );
  };



  const renderHistory = () => {
    return (
      <div className="history-container">
        <div className="total-bet-counter">
          Total place count {winningDrawList.length}
        </div>
        {winningDrawList.map((item: any, index: number) => {
          return (
            <div key={uuidv4()} className="history-item">
              <div style={{ fontWeight: "400", color: "#f1f1f1" }}>
                Ticket Number: {index + 1}
              </div>
              {betAmount && (
                <div
                  style={{
                    display: "flex",
                    width: "100%",
                    justifyContent: "space-between",
                    fontWeight: "bold",
                    color: "white",
                  }}
                >
                  Win: {item.scoreCount * parseFloat(betAmount) || 0}
                </div>
              )}
              <div>Winning Numbers</div>
              {item.winning.sort((a: number, b: number) => a > b ? 1 : -1).map((n: number) => (
                <span className="winning-number" key={uuidv4()}>
                  {n + " "}
                </span>
              ))}
              <div>Your place numbers</div>
              {item.picked.sort((a: number, b: number) => a > b ? 1 : -1).map((n: number) => (
                <span
                  className={`picked-number ${item.winning.indexOf(n) !== -1 && "picked-win-number"
                    }`}
                  key={uuidv4()}
                >
                  {n + " "}
                </span>
              ))}
            </div>
          );
        })}
      </div>
    );
  };

  return (
    <div>
      <div style={{ display: "flex", justifyContent: "center" }}>
        Pick 1 ~ {pickLimit} Keno spots by clicking on the number in the Keno
        card.
      </div>

      <div className="keno">
        <Stack
          style={{
            alignItems: "center",
            display: "flex",
            justifyContent: "center",
            borderStyle: "solid",
            borderColor: "#888888",
            borderWidth: 1,
            borderRadius: 10,
            paddingTop: 8,
            paddingBottom: 8,
            marginTop: 30,
          }}
        >
          <Stack
            className={"mt-2 flex-col"}
          >
            <Stack className={isLessSmall ? "flex-col justify-content-center p-2 gap-2" : "flex-row justify-content-center"}>
              <div className="bet-amount">
                Diamond Amount
                <Form.Select
                  value={betAmount}
                  style={{ width: 90, marginLeft: 5 }}
                  onChange={(e) => {
                    setBetAmount(e.target.value);
                  }}
                >
                  {amountList.map((item) => (
                    <option key={item} value={item}>
                      {item}
                    </option>
                  ))}
                </Form.Select>
              </div>

              <div className="bet-amount">
                Draws
                <Form.Select
                  value={repeatNumberView}
                  style={{ width: 90 }}
                  onChange={(e) => {
                    setRepeatNumberView(parseInt(e.target.value));
                  }}
                >
                  <option value="1">1</option>
                  <option value="2">2</option>
                  <option value="3">3</option>
                  <option value="4">4</option>
                  <option value="5">5</option>
                  <option value="10">10</option>
                  <option value="20">20</option>
                  <option value="50">50</option>
                </Form.Select>
              </div>

              <div className="current-round">Round: {currentRound + 1}</div>
            </Stack>

            <Stack className={isLessSmall ? "flex-col justify-content-center p-2 gap-2" : "flex-row justify-content-center gap-4 mt-3"}>
              <Button
                variant="secondary"
                onClick={clearHandler}
              >
                Clear <AiOutlineClear />
              </Button>

              <Dropdown>
                <Dropdown.Toggle variant="info">Lucky Pick</Dropdown.Toggle>

                <Dropdown.Menu>
                  <Dropdown.Item
                    onClick={() => {
                      quikPik(1);
                    }}
                  >
                    1
                  </Dropdown.Item>
                  <Dropdown.Item
                    onClick={() => {
                      quikPik(2);
                    }}
                  >
                    2
                  </Dropdown.Item>
                  <Dropdown.Item
                    onClick={() => {
                      quikPik(3);
                    }}
                  >
                    3
                  </Dropdown.Item>
                  <Dropdown.Item
                    onClick={() => {
                      quikPik(4);
                    }}
                  >
                    4
                  </Dropdown.Item>
                  <Dropdown.Item
                    onClick={() => {
                      quikPik(5);
                    }}
                  >
                    5
                  </Dropdown.Item>
                  <Dropdown.Item
                    onClick={() => {
                      quikPik(6);
                    }}
                  >
                    6
                  </Dropdown.Item>
                  <Dropdown.Item
                    onClick={() => {
                      quikPik(7);
                    }}
                  >
                    7
                  </Dropdown.Item>
                  <Dropdown.Item
                    onClick={() => {
                      quikPik(8);
                    }}
                  >
                    8
                  </Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>

              {account &&
                !showPlayAgain &&
                ((
                  <Button
                    variant="success"
                    onClick={submitHandler}
                  >
                    Submit
                  </Button>
                ) as any)}

              {showPlayAgain && (
                <Button
                  variant="secondary"
                  onClick={submitHandler}
                >
                  <AiOutlineReload />
                  &nbsp; Play Again
                </Button>
              )}
            </Stack>

          </Stack>
        </Stack>
        <Stack
          className={isSmall ? "mt-2 flex-col gap-2" : "mt-2 flex-row-reverse gap-2"}
        >
          {renderBoard()}
          {renderHistory()}
        </Stack>
      </div>
    </div>
  );
}
